import { usePage } from "@inertiajs/react";

export default function Flash() {
  const { flash } = usePage().props;

  if (!flash?.alert && !flash?.notice) return null;

  const isError = !!flash.alert;
  const message = flash.alert || flash.notice;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[90%] max-w-sm">
      <div
        className={`rounded-lg border px-4 py-3 text-sm shadow-md ${
          isError
            ? "border-destructive/30 bg-destructive/10 text-destructive"
            : "border-border bg-card text-foreground"
        }`}
      >
        {message}
      </div>
    </div>
  );
}
